// src/pages/Dashboard/Admin/DepensesRecettesDashboard/components/ChartsDrawer.jsx

import React from "react";
import AccountingDrawer from "./AccountingDrawer";
import AccountingCharts from "./AccountingCharts";
import { fmtEUR } from "../utils/accountingDashboardUtils";

export default function ChartsDrawer({
  open,
  onClose,
  rows = [],
  saison,
  totals,
  stats,
}) {
  return (
    <AccountingDrawer
      open={open}
      onClose={onClose}
      title="Graphiques financiers"
      subtitle="Analyse des flux, du solde cumulé et des répartitions par catégories."
      size="2xl"
    >
      <div className="mb-5 grid gap-3 sm:grid-cols-3">
        <SummaryCard label="Dépenses" value={fmtEUR(totals?.depense)} tone="rose" />
        <SummaryCard label="Recettes" value={fmtEUR(totals?.recette)} tone="emerald" />
        <SummaryCard
          label="Solde"
          value={fmtEUR(totals?.solde)}
          tone={Number(totals?.solde || 0) >= 0 ? "emerald" : "rose"}
        />
      </div>

      <div className="mb-5 flex flex-wrap gap-2 text-xs font-bold text-slate-600 dark:text-slate-300">
        {saison ? (
          <span className="rounded-full bg-indigo-50 px-3 py-1 text-indigo-700 ring-1 ring-indigo-100 dark:bg-indigo-500/10 dark:text-indigo-300 dark:ring-indigo-500/20">
            Saison {saison}
          </span>
        ) : (
          <span className="rounded-full bg-slate-100 px-3 py-1 dark:bg-slate-800">
            Toutes saisons
          </span>
        )}

        <span className="rounded-full bg-slate-100 px-3 py-1 dark:bg-slate-800">
          {rows.length} opération(s)
        </span>

        <span className="rounded-full bg-slate-100 px-3 py-1 dark:bg-slate-800">
          {stats?.categoriesCount || 0} catégorie(s)
        </span>
      </div>

      {rows.length === 0 ? (
        <div className="rounded-[24px] border border-dashed border-slate-300 bg-slate-50 p-10 text-center dark:border-slate-700 dark:bg-slate-900/60">
          <p className="text-lg font-bold text-slate-900 dark:text-white">
            Aucune donnée à analyser
          </p>
          <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
            Ajoutez des opérations ou modifiez les filtres.
          </p>
        </div>
      ) : (
        <AccountingCharts rows={rows} saison={saison} />
      )}
    </AccountingDrawer>
  );
}

function SummaryCard({ label, value, tone }) {
  const tones = {
    rose: "border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300",
    emerald:
      "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300",
  };

  return (
    <div className={`rounded-2xl border p-4 ${tones[tone]}`}>
      <p className="text-[11px] font-bold uppercase tracking-[0.18em] opacity-70">
        {label}
      </p>
      <p className="mt-1 text-xl font-bold text-slate-950 dark:text-white">
        {value}
      </p>
    </div>
  );
}